module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_vm._m(0), _vm._v(" "), (this.$store.getters.getUserRoles[15]) ? _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "to": '/account-details?general_search=&account_status=%5B%5D&account_mrc=%5Bnull,null%5D&latest_comms=%5Bnull,null%5D&ink_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&term_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&subagents=%5B%22' + encodeURI(_vm.agentProfile.name) + '%22%5D&approved=%5B%5D&estimated_comms=%5Bnull,null%5D&term=%5Bnull,null%5D&expected_spiff=%5Bnull,null%5D&actual_spiff=%5Bnull,null%5D&actual_delta=%5Bnull,null%5D&off_expected=%5Bnull,null%5D&spiff_delta=%5Bnull,null%5D&telno=&telno_carriers=&name=&carrier_name=&telno_carrier=&columns=%5B%22ink_date%22,%22term%22,%22name%22,%22carrier_name%22,%22subagents%22%5D&sort=%5B%7B%22field%22%3A%22ink_date%22,%22dir%22%3A%22DESC%22%7D%5D&page=1&limit=25'
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link-square"
  }), _vm._v("  View Co-sold Accounts")]), _vm._v(" "), (_vm.editing != 'info') ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.editInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v("  Edit")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('span', [_c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": _vm.saveInfo
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear btn-sm",
    on: {
      "click": function($event) {
        _vm.editing = null
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-6 col-sm-2 col-form-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.agentProfile.name || '-') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.name),
      expression: "selected.name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.name = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.agentProfile.email || '-') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.email),
      expression: "selected.email"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.email = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.agentProfile.username || '-') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.username),
      expression: "selected.username"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.username = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing != 'info'),
      expression: "editing != 'info'"
    }]
  }, [_vm._v("******")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing == 'info'),
      expression: "editing == 'info'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.new_password),
      expression: "selected.new_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "password",
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": _vm._s(_vm.selected.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.new_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing == 'info'),
      expression: "editing == 'info'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.new_password_confirm),
      expression: "selected.new_password_confirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Repeat new password"
    },
    domProps: {
      "value": _vm._s(_vm.selected.new_password_confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.new_password_confirm = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Telno")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n            " + _vm._s(_vm.agentProfile.telno || '-') + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.telno),
      expression: "selected.telno"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.telno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.telno = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n            " + _vm._s(_vm._f("displayStatus")(_vm.agentProfile.status)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('dropdown', {
    attrs: {
      "list": _vm.statuses,
      "value": _vm._f("displayStatus")(_vm.selected.status)
    },
    on: {
      "change": _vm.setStatus,
      "input": _vm.setStatus
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.agentProfile.is_channel) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Channel")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.agentProfile.channel_name || '-') + "\n         ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('autocomplete', {
    attrs: {
      "list": _vm.channelNames,
      "selection": _vm.selected.channel_name
    },
    on: {
      "input": _vm.fetchChannels,
      "change": _vm.setChannel
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Referrer")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-4 col-lg-3"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.agentProfile.referrer_name || '-') + "\n         ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('autocomplete', {
    attrs: {
      "list": _vm.referrerNames,
      "selection": _vm.selected.referrer_name
    },
    on: {
      "input": _vm.fetchAgents,
      "change": _vm.setReferrer
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.agentProfile.is_channel) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Company")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.agentProfile.company_name || '-') + "\n         ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.company_name),
      expression: "selected.company_name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.company_name = $event.target.value
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Sandler ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.agentProfile.sandler_id || '-') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.sandler_id),
      expression: "selected.sandler_id"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.sandler_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.sandler_id = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [(_vm.editing != 'info') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.agentProfile.sandler_username || '-') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.editing == 'info') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.sandler_username),
      expression: "selected.sandler_username"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.selected.sandler_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.sandler_username = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing != 'info' && !_vm.showPass),
      expression: "editing != 'info' && !showPass"
    }]
  }, [_vm._v("******    \n          "), _c('button', {
    staticClass: "btn btn-sm btn-light",
    on: {
      "click": function($event) {
        _vm.showPass = true
      }
    }
  }, [_vm._v("Show")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing != 'info' && _vm.showPass),
      expression: "editing != 'info' && showPass"
    }]
  }, [_vm._v(_vm._s(_vm.agentProfile.sandler_password) + "    "), _c('button', {
    staticClass: "btn btn-sm btn-light",
    on: {
      "click": function($event) {
        _vm.showPass = false
      }
    }
  }, [_vm._v("Hide")])]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing == 'info'),
      expression: "editing == 'info'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.sandler_password),
      expression: "selected.sandler_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": _vm._s(_vm.selected.sandler_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.sandler_password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-xs-12 col-sm-2 col-form-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-10"
  }, [_c('div', {
    staticClass: "tag-search"
  }, [_c('autocomplete', {
    attrs: {
      "placeholder": "Enter a Tag",
      "list": _vm.tagNames,
      "selection": _vm.tag,
      "loose": "",
      "allowNew": ""
    },
    on: {
      "input": _vm.searchTags,
      "change": _vm.createTag,
      "enter": _vm.createTag
    }
  })], 1), _vm._v(" "), _vm._l((_vm.agentTags), function(t) {
    return _c('div', {
      key: t.userTag_id,
      staticClass: "tag"
    }, [_vm._v("\n        " + _vm._s(t.name) + " "), _c('i', {
      staticClass: "fa fa-remove",
      on: {
        "click": function($event) {
          _vm.removeTag(t.userTag_id);
        }
      }
    })])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("Agent Info")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77ea35e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agents/AgentInfo.vue
// module id = 406
// module chunks = 0